import { RetailerPage, fetchRetailerData, fetchRetailerDataSuccess } from 'src/modules/retailer';
import { wrapper } from 'src/store';

export const getStaticProps = wrapper.getStaticProps(async (ctx) => {
  const data = await fetchRetailerData();
  ctx.store.dispatch(fetchRetailerDataSuccess(data.stores));

  return { props: { retailerPage: data } };
});

export default RetailerPage;
